import { baseURL } from "../services/api";

const endpoints = {
  getMenu: "/menu",
  getFooter: "/users/is_logged",
  getUserList: "/users/list",
  createOrUpdateUser: "/users/save",
  getUserById: "/users/find",
  changeUserStatusById: "users/update_status",
  getAffiliationOptions: "/users/affiliation_options",
  logOut: "/users/sign_out",
  logIn: "/users/sign_in",
  getPermission: "/users/permission",
  getAllowCreateNewDevicePermission: "/devices/allowCreateNewDevice",
  getAffiliation: "/users/affiliations",
  getLogsList: "/logs/list",
  getLogsById: "/logs/find",
  exportCsvLogs: "/logs/csv",
  saveLog: "/logs/save",
  getRolesList: "/roles/list",
  getRolesDetails: "/roles/details",
  getRoleDetails: "/permissions/list",
  deleteRoleById: "/roles/delete",
  createRole: "/roles/save",
  getRoleById: "/roles/find",
  smartSearch: "/smartsearch/list",
  smartSearchGames: "/smartsearch/listgames",
  getCashiersList: "/cashiers/list",
  updateCashierStatus: "/cashiers/update_status",
  createOrUpdateCashier: "/cashiers/save",
  getCashierById: "/cashiers/find",
  getDrawerCashiersList: "/drawercashiers/list",
  updateDrawerCashiers: "/drawercashiers/update",
  getDevicesList: "/devices/list",
  getDeviceById: "/devices/find",
  createOrUpdateDevice: "/devices/save",
  pushDeviceCommand: "/devices/pushCommand",
  exportCsvDevices: "/devices/csv",
  getListDeviceBulkEdit: "/devices/list_bulk_edit",
  pushDeviceBulkEdit: "devices/bulk_edit_action",
  getDeviceVersionsList: "/deviceversions/list",
  exportCsvDeviceVersions: "/deviceversions/csv",
  deleteDeviceVersionById: "/deviceversions/delete",
  createOrUpdateDeviceVersions: "/deviceversions/save",
  getDeviceVersionById: "/deviceversions/find",
  getDistributorsList: "/distributors/list",
  changeDistributorStatus: "/distributors/update_status",
  getDistributorServers: "/distributorservers/list",
  changeServerStatus: "/distributorservers/update_status",
  deleteServerById: "/distributorservers/delete",
  changeDefaultServerById: "/distributorservers/setdefaultserver",
  createOrUpdateServer: "/distributorservers/save",
  getServerById: "/distributorservers/find",
  createOrUpdateDistributor: "/distributors/save",
  getDistributorById: "/distributors/find",
  getCharitiesList: "/charities/list",
  getCharityById: "/charities/find",
  updateCharityStatus: "/charities/update_status",
  createOrUpdateCharity: "/charities/save",
  getLocationsList: "/locations/list",
  getLocationById: "/locations/find",
  createOrUpdateLocation: "/locations/save",
  updateLocationStatus: "/locations/update_status",
  validatePermitCode: "/locations/exist_permit",
  getPulltabGames: "/games/list",
  deleteGameById: "/games/delete",
  getPulltabGameById: "/games/find",
  updateGameSettings: "/games/update",
  uploadGame: `${baseURL}games/upload`,
  uploadBingoGame: `${baseURL}bingodefinition/upload`,
  getPulltabGameFlare: "/boxes/flare",
  getGamesList: "/decksmanagement/games",
  getGamesToCopy: "/decksmanagement/apply",
  getDecksList: "/decksmanagement/list",
  updateDecksList: "decksmanagement/save",
  getPulltabDecksList: "/boxes/list",
  updatePulltabDecks: "/boxes/save",
  closePulltabDecks: "/boxes/close",
  getBingoConfig: "/bingoconfig/view",
  updateBingoConfig: "/bingoconfig/save",
  getLobbyOrder: "/gameorderings/list",
  updateLobbyOrder: "/gameorderings/save",
  getBingoGamesList: "/bingogames/list",
  updateBingoGames: "/bingogames/save",
  smartSearchBingoGames: "/bingodefinition/search",
  getBingoDefinitionsList: "/bingodefinition/list",
  getBingoDefinitionsDetail: "/bingodefinition/details",
  deleteBingoGameById: "/bingodefinition/delete",
  getQueueStatus: "/queuestatus/list",
  getDrawerManagement: "/drawermanagement/list",
  saveDrawerManagement: "/drawermanagement/save",
  getSeasonalManagement: "/seasonalmanagement/list",
  saveSeasonalManagement: "/seasonalmanagement/save",
  getBundleManagement: "/games/list_bundles",
  saveBundleManagement: "/games/update_bundles",
  getPosBlundleServerList: "/posbundleservermanagement/list",
  updatePosBundleServerList: "/posbundleservermanagement/save",
  disableIncompatiblePosBlundleServerList: "/posbundleservermanagement/disableIncompatible",
  getDecksStatusList: "/decksstatus/list",
  closeDecks: "/decksstatus/close",
  getJackpotsList: "/jackpots/list",
  getJackpotById: "/jackpots/find",
  getJackpotHistory: "/jackpotshistory/list",
  getAvaliableGamesWithWager: "/jackpots/available_games_by_wager",
  saveJackpot: "/jackpots/save",
  addAddition: "/jackpots/addition",
  changeJackpotStatusById: "/jackpots/update_status",
  getJackpotPaymentsList: "/jackpotspayrolls/list",
  getJackpotPastPaymentById: "/jackpotspayrolls/find_past_payment",
  getJackpotPendingPaymentById: "/jackpotspayrolls/find_pending_payment",
  saveJackpotPayment: "/jackpotspayrolls/save",
  getConfigsList: "/manufacturerconfig/view",
  saveConfigList: "/manufacturerconfig/save",
  createFee: "/manufacturerconfig/add_fee",
  deleteFee: "/manufacturerconfig/remove_fee",
  refreshCompanyCache: '/manufacturerconfig/reload_company_cache',
  getLocationTopology: "/locationtopology/list",
  getMigrationQueueItems: "/migrationqueue/view",
  saveMigrationQueueItems: "/migrationqueue/save",
  getMigrationStatus: "/migrationstatus/view",
  getRunningMigration: "/migrationstatus/view_config",
  startMigration: "/migrationstatus/start_migration",
  stopMigration: "/migrationstatus/stop_migration",
  deleteMigration: "/migrationstatus/delete",
  getMigrationDetails: "/migrationstatus/details",
  getRealTimeLocationStatus: "/reports-realtime/realtimelocationstatus",
  getDashboard: "/reports-realtime/dashboard",
  getClosedPullTabGames: "/reports-pulltabs/closedpulltabgames",
  historicalinventory: "/reports-pulltabs/historicalinventory",
  historicaltransactionlog: "/reports-analysis/historicaltransactionlog",
  currentinventory: "/reports-pulltabs/currentinventory",
  currentpulltabgames: "/reports-pulltabs/currentpulltabgames",
  deckStatus: "/reports-pulltabs/deckstatus",
  distributorgame: "/reports-pulltabs/distributorgame",
  gamedefinition: "/reports-pulltabs/gamedefinition",
  locationinventory: "/reports-pulltabs/locationinventory",
  monthend: "/reports-pulltabs/monthend",
  gamedefinition_filter: "/reports-pulltabs/gamedefinition_filter",
  getLocationListReport: "/reports-system/locationlist",
  getUserListReport: "/reports-system/userlist",
  getRevenueByDayOfWeek: "/reports-analysis/revenuebydayofweek",
  getDeviceUtilization: "/reports-analysis/deviceutilization",
  cashieractivity: "/reports-financial/cashieractivity",
  dailyDeposit: "/reports-financial/dailydeposit",
  dailyDepositSales: "/reports-financial/dailydepositsales",
  dailySalesDetail: "/reports-financial/dailysalesdetail",
  periodRevenue: "/reports-financial/periodrevenue",
  monthlyReports: "/reports-financial/monthlyreports",
  largeCashOut: "/reports-financial/largecashoutactivity",
  locationLG861e: "/reports-financial/lg861e",
  getGamePerformanceReport: "/reports-analysis/gameperformance",
  getBingoAccount: "/reports-bingo/bingoaccount",
  getBingoCharityInvoice: "/reports-bingo/bingocharityinvoice",
  getBingoDistributor: "/reports-bingo/bingodistributorstatement",
  getBingoGameLog: "/reports-bingo/bingogamelog",
  getGamePerformanceWithVariants:
    "/reports-analysis/gameperformancewithvariants",
  getDrawerActivityReport: "/reports-analysis/draweractivity",
  getMonthlyReports: "/reports-financial/monthlyreports",
  getMonthlyReportsGameTypeFilter: '/reports-financial/monthlyreports_gametype',
  getRevenueByDevice: "/reports-analysis/revenuebydevice",
  getCharitiesProgressiveContribution:
    "/reports-bingo/bingocharitiesprogressivecontribution",
  charitiesProgressiveContribution_filter:
    "/reports-bingo/bingocharitiesprogressivecontribution-filter",
  getRevenueByGame: "/reports-analysis/revenuebygame",
  getRevenueByPeriod: "/reports-analysis/revenuebyperiod",
  getBingoLBPMonthly: "/reports-bingo/bingolbpmonthly",
  getProgressiveContributions:
    "/reports-bingo/bingoprogressivecontribution-filter",
  getBingoProgressiveContribution:
    "/reports-bingo/bingoprogressivecontribution",
  getBingoJackpotWinners: "/reports-bingo/bingojackpotwinners",
  getBingoActiveProgressives: "/reports-bingo/bingoactiveprogressives",
  getBingoActiveSites: "/reports-bingo/bingoactivesites",
  getBingoPlayReport: "/reports-bingo/bingoplay",
  getBingoPerformanceReport: "/reports-bingo/bingoperformance",
  getPOSBundleStatusReport: "/reports-system/posbundlestatus",
  getStorageUsageReport: "/reports-system/storageusage",
  getStorageUsageDetailReport: "/reports-system/storageusagedetail",
  getStorageUsageVersions: "reports-system/storageusage/versions",
  getAllTags: "/tags/get_all_tags",
  getDeviceTags: "/tags/get_device_tags",
  addTag: "/tags/add_tag",
  deleteTag: "/tags/delete_tag",
  addTagToDevices: "/tags/add_tag_to_devices",
  removeTagFromDevices: "/tags/remove_tag_from_devices",

};

export default endpoints;
